
import { AttributesConfig, error99, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'

export const UserService = {

    SaveTema: async (theme: any): Promise<RetAPI> => {

        const resp = await Api('User/Theme/Update', 'put', {

            tema: theme.tema,
            cor_tema: theme.cor_tema
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',

                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    SaveVariacao: async (variacao: any): Promise<RetAPI> => {

        let id = ''

        if (variacao.id) {
            id = variacao.id.toString()
        }

        const resp = await Api('Config/Save', 'post', {

            desc_variacao: variacao.desc_variacao,
            desc_sub_variacao: variacao.desc_sub_variacao,
            id
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
                id: resp.data.config.id
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    SaveJuros: async (juros: any): Promise<RetAPI> => {

        let id = ''

        if (juros.id) {
            id = juros.id.toString()
        }

        const resp = await Api('Juros/Save', 'post', {

            taxa_juros: juros.taxa_juros,
            dias: juros.dias,
            id
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
                id: resp.data.juros.id
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    FindConfig: async (): Promise<RetAPI> => {

        const resp = await Api('Config/Find', 'get')
        const config: AttributesConfig = {
            config: {
                id: 0,
                id_empresa: 0,
                id_user_insert: 0,
                desc_variacao: '',
                desc_sub_variacao: '',
                dt_cadastro: ''
            },
            juros: {
                id: 0,
                id_empresa: 0,
                id_user_insert: 0,
                id_user_last_update: 0,
                taxa_juros: 0,
                dias: 0,
                dt_cadastro: '',
                dt_last_update: ''
            }
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: config
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.configuracao) {

                    let configuracao = {

                        id: resp.data.configuracao.id,
                        desc_variacao: resp.data.configuracao.desc_variacao,
                        desc_sub_variacao: resp.data.configuracao.desc_sub_variacao,
                        id_empresa: resp.data.configuracao.id_empresa,
                        id_user_insert: resp.data.configuracao.id_user_insert,
                        dt_cadastro: resp.data.configuracao.dt_cadastro
                    }

                    config.config = configuracao

                }

                if (resp.data.juros) {

                    let taxasJuros = {

                        id: resp.data.juros.id,
                        id_empresa: resp.data.juros.id_empresa,
                        id_user_insert: resp.data.juros.id_user_insert,
                        id_user_last_update: resp.data.juros.id_user_last_update,
                        taxa_juros: resp.data.juros.taxa_juros,
                        dias: resp.data.juros.dias,
                        dt_cadastro: resp.data.juros.dt_cadastro,
                        dt_last_update: resp.data.juros.dt_last_update

                    }

                    config.juros = taxasJuros

                }

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: config
            }
        }

        return {
            error: false,
            data: config
        }
    },

    BuscarUsuario: async (): Promise<RetAPI> => {

        const resp = await Api('auth/getUser', 'get')

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
                data: resp.data.user,
            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    UsuarioList: async (nome?: string): Promise<RetAPI> => {

        const resp = await Api('User/List', 'get', { nome: nome })
        const usuario: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: usuario
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.usuarios.map((item: any) => {

                    return usuario.push({
                        id: item.id,
                        nome: item.nome,
                        email: item.email

                    })
                })



            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: usuario
            }
        }

        return {
            error: false,
            msg: '',
            data: usuario || []
        }
    },

    saveUser: async (nome: string, email: string, password: string, confirm_password: string, documento: string): Promise<RetAPI> => {

        const resp = await Api('auth/createUser', 'post', {

            nome: nome,
            email: email,
            password: password,
            confirm_password: confirm_password,
            documento: documento
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    }
}
